import { axios } from '~/common/utils/request';
import {trackDefaults} from '~/common/utils/json'
import { storage } from './storage';
const activeRoutes = { //可以埋点路由统计
  'portal':{
    'brand': {},
    'spu': {},
    'sku': {},
    'category': {},
    'post': {},
    'image': {},
    'all': {},
    store:{
      register:{}
    }
  },
  srvContent:{
    view: {}
  }
}
const getTrackData =  ({$route,value}) => {
  const values = Array.isArray(value) ? value : value ? [value] : [];
  const origin = window.location.origin
  let path = '/' +  $route.path.split('/').filter(v => !!v).splice(0,2).join('/')
  let tmp = values.map((v) => {
    const json = {
      menu: trackDefaults[path]?.menu ? trackDefaults[path].menu : '',
      object_type: trackDefaults[path]?.object_type ? trackDefaults[path].object_type : '',
      url: origin + $route.fullPath, // 包含查询参数的完整路径
      ...v,
    }
    json.menu_name = json.menu
    if(v.refer_url && !/http/.test(v.refer_url)) {
      json.refer_url = origin +json.refer_url
    }
    if(v.url && !/http/.test(v.url)) {
      json.url = origin +json.url
    }
    if(v.click_url && !/http/.test(v.click_url)) {
      json.click_url = origin +json.click_url
    }
    let object_code = ''
    const tmp = new URL(json.url)
    if(json.object_code) {
      object_code = json.object_code === '-1' ? '-1' : json.object_code
    }else if(v.page_type === 'list') {
      object_code = '-1'
    }
    else if(tmp.searchParams.has('id')) {
      object_code = tmp.searchParams.get('id')
    }
    json.object_code = object_code
    if(v.page_type === 'detail') {
      const routeStorageData = storage.get($route.path, true)
      if(routeStorageData) {
        if(json.url.indexOf($route.path) > -1) {
          const {detailName} = routeStorageData
          json.title = json.menu_name + '：' + detailName
        } else {
        }
      }
    }
    return json
  });
  return tmp;
}
const fetch = async (params) => {
  const { code, data } = await axios({
    // url: `/rest/store/general-website/v3/visit/create`,
    url: `api/website/v3/visit/create`,
    method: 'post',
    data:{
      ...params,
      use_nats: true
    }
  })
}
export const trackEventApi = async ({$route,value}) => {
  const resValues = getTrackData({$route,value})
  resValues.forEach(v => {
    fetch(v)
  })
}

